import { Injectable } from '@angular/core';
import { APIService, HttpParamsObject } from './api.service';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectBffBaseUrl } from '../../store/selectors/api-config.selectors';
import { TranslocoService } from '@jsverse/transloco';
import { map, switchMap } from 'rxjs/operators';
import { LocaleInfo } from '@shared/services/locale.service';

@Injectable({ providedIn: 'root' })
export class SupportApiService {
  private basePath: string;
  private basePath$: Observable<string>;

  constructor(
    private apiService: APIService,
    private translocoService: TranslocoService,
    private store: Store,
  ) {
    this.basePath$ = this.store.pipe(
      selectBffBaseUrl,
      map((url) => `${url}/app/support`),
    );
    this.store.pipe(selectBffBaseUrl).subscribe((url) => {
      this.basePath = `${url}/app/support`;
    });
  }

  public getFAQ(
    resource: string,
    paramsObject?: HttpParamsObject,
  ): Observable<any> {
    const lang = this.translocoService.getActiveLang();
    const headers = { 'Accept-Language': lang };
    return this.apiService.callGetAPI(
      `${this.basePath}/${resource}`,
      paramsObject,
      headers,
    );
  }

  public sendRequest(resource: string, body): Observable<any> {
    const responseType = 'text';
    return this.apiService.callPostAPI(
      `${this.basePath}/${resource}`,
      body,
      responseType,
    );
  }

  public getSupportedLocales$() {
    return this.basePath$.pipe(
      switchMap((basePath) =>
        this.apiService.callGetAPI<{
          defaultLocale: string;
          supportedLocales: LocaleInfo[];
        }>(`${basePath}/locales`),
      ),
    );
  }
}
